import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";
import { rosettaAtom } from "~/lib/rosetta";

import IconCaretForward from "./icon-caret-forward.svg";
import {
  Container,
  InstructionButton,
  InstructionButtonText,
  InstructionText,
  StyledBaseLink,
} from "./styles";

type Props = {
  className?: string;
};
export const HamburgerMenuSubscriberInstruction: FunctionComponent<Props> = ({ className }) => {
  const asyncRosettaState = useAtomValue(rosettaAtom);

  const subscribeClickedHandler = () => {
    sendGATracking({
      action: "Menu/Click",
      category: "Menu",
      label: "Menu/Subscribe",
    });

    const subscriberPhase = asyncRosettaState?.result?.tracking?.ga4?.subscriberPhase;
    sendGA4Tracking({
      action: "click",
      category: "subs",
      customized_parameters: {
        call_to_action: "subscribe",
        subscriber_phase: subscriberPhase,
        trigger_point: "hamburger menu",
      },
      subcategory: "entry_point",
    });
  };

  return (
    <Container className={className}>
      <InstructionButton>
        <StyledBaseLink pathname="https://subscribe.scmp.com/" onClick={subscribeClickedHandler}>
          <InstructionButtonText>SUBSCRIBE</InstructionButtonText>
          <IconCaretForward />
        </StyledBaseLink>
      </InstructionButton>

      <InstructionText>Get unlimited access to the SCMP</InstructionText>
    </Container>
  );
};
